package ca.sebleclerc.siteapp.repositories

import ca.sebleclerc.network.IAPIService

interface Repositoryable

open class Repository(val apiService: IAPIService) : Repositoryable
